import {
  createRouter,
  createWebHistory
} from 'vue-router'
import * as Sentry from '@sentry/browser'
import { loggerService } from '@/_services/loggerService'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import StepUp from '../views/admin/StepUp.vue'
import Dashboard from '../views/admin/Dashboard.vue'
import PageOperations from '../views/admin/PageOperations.vue'
import PageCampaign from "@/views/admin/PageCampaign.vue";
import AdminLayout from '../views/admin/AdminLayout.vue'
import ResetPassword from '../views/ResetPassword.vue'
import {
  authGuard
} from '@/_helper/auth-guard'
import i18n from "@/_helper/translation";
import StepUpRegister from '../views/admin/StepUpRegister.vue'
import StepUpPhoneNumber from "@/views/admin/StepUpPhoneNumber.vue";

const { t } = i18n.global;

const routes = [{
    path: '/',
    name: 'login',
    component: Login,
    meta: {
      title: t("pageTitle.login")
    }
  },
  {
    path: '/invite/consume',
    name: 'Register',
    component: Register,
    meta: {
      title: t("pageTitle.register")
    }
  },
  {
    path: '/set-password/:token/:email',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      title: t("pageTitle.resetPassword")
    }
  },
  {
    path: '/Admin',
    name: 'Admin',
    component: AdminLayout,
    children: [
      {
        path: 'Dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          title: t("pageTitle.dashboard")
        }
      },
      {
        path: 'Operations',
        name: 'Operations',
        component: PageOperations,
        meta: {
          title: t("pageTitle.operations")
        }
      },
      {
        path: 'Campaigns/:campaignUuid',
        name: 'Campaign',
        component: PageCampaign,
        meta: {
          title: t("pageTitle.campaign")
        }
      },
      {
        path: 'StepUp',
        name: 'StepUp',
        component: StepUp,
        meta: {
          title: t("pageTitle.stepUp")
        }
      },
      {
        path: 'StepUpPhoneNumber',
        name: 'StepUpPhoneNumber',
        component: StepUpPhoneNumber,
        meta: {
          title: t("pageTitle.stepUpPhoneNumber")
        }
      },
      {
        path: 'StepUpRegister',
        name: 'StepUpRegister',
        component: StepUpRegister,
        meta: {
          title: t("pageTitle.stepUpRegister")
        }
      },
      {
        path: '/:pathMatch(.*)*',
        redirect: '/admin/Dashboard'
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  authGuard(to);

  document.title = to.meta?.title ?? t("pageTitle.default");
  
  // Add route change to Sentry breadcrumbs
  Sentry.addBreadcrumb({
    category: 'navigation',
    message: `Navigating from ${from.name || 'unknown'} to ${to.name || 'unknown'}`,
    data: {
      from: from.path,
      to: to.path,
      fromName: from.name,
      toName: to.name
    },
    level: 'info'
  });
  
  // Log route changes
  loggerService.debug(`Route change: ${from.path} → ${to.path}`, {
    fromRoute: from.name,
    toRoute: to.name,
    requiresAuth: to.meta?.requiresAuth
  });

  next()
})

export default router